import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import{ GlobalConstants } from '../../app/common/global-variable';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  type: any;
  constructor(private afs: AngularFireAuth) { }

  ngOnInit(): void {        
    this.type = localStorage.getItem("type");    
    this.afs.currentUser.then((d) => {
      
      localStorage.setItem("userID", d.uid)
      d.getIdToken().then((d) => {
        localStorage.setItem("token", d);
      })
    })
  }

}
